
  import { LegacyItem } from '@/ui/components/inspectionReport/legacyTypes';
  import RichText from '@/ui/components/richText/RichText.vue';
  import { defineComponent } from 'vue';
  import { ItemProps } from '@/ui/components/inspectionReport/types';
  import { useInspectionReport } from '@/ui/components/inspectionReport/useInspectioReport';

  export default defineComponent<ItemProps>({
    components: { RichText },
    props: {
      item: {
        type: Object as () => LegacyItem,
        required: true,
      },
    },
    setup() {
      const { getNotRespondedAnswer } = useInspectionReport();
      return {
        getNotRespondedAnswer,
      };
    },
  });
